import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getQuoteStatusData } from "../redux/pricingplanSlice";

export const useQuoteStatus = () => {
  const dispatch = useDispatch();
  const [userStatus, setUserStatus] = useState([]);

  useEffect(() => {
    const loadQuoteStatus = async () => {
      try {
        const response = await dispatch(getQuoteStatusData()).unwrap();
        const responseData = response?.data?.data || [];
        const formatted = responseData.map((s) => ({
          value: s.id,
          label: s.status
        }));
        setUserStatus(formatted);
      } catch {
        // handle catch here;
      }
    };
    loadQuoteStatus();
  }, [dispatch]);

  return userStatus;
};
